import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { GenericListProps } from "../../types/GenericListType";
import { GroupedComponents } from "../../components/GroupedComponents";

export interface ReferenceMapsPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  applyButton?: LinkButtonProps;
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const ReferenceMapsPage: React.FC<ReferenceMapsPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  applyButton,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      {linksList && linksList[0] && <Links {...linksList[0]} />}
      {applyButton && <LinkButton {...applyButton} />}
    </ServiceCataloguePageWrapper>
  );
};
